import type { FC } from 'react';
import InputMultiSelect from '@components/InputMultiSelect';
import { COMPACT_MULTI_SELECT_STYLE_PROPS } from '@components/InputMultiSelect/constants';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { XIcon } from '@heroicons/react/solid';
import { mdiTagOutline } from '@mdi/js';
import Icon from '@mdi/react';
import type { Tag } from '@root/@types/types';

import { countBadgeClasses } from './classes';
import type { TagComponentProps } from './types';

export const MultipleTagsButton: FC<TagComponentProps> = ({
  handleCancelUpdateItemTags,
  handleChangeItemTags,
  handleUpdateItemTags,
  hasChanges,
  isUpdatingItemTags,
  itemTagsIds,
  savedTagsLabels,
  open,
  setOpen,
  tags,
  popoverTriggerRef,
}) => {
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <span ref={popoverTriggerRef} className={countBadgeClasses}>
          <span>{`${savedTagsLabels.length} Tags`}</span>
          <Icon path={mdiTagOutline} size={0.5} className="inline-block flex-shrink-0" />
        </span>
      </PopoverTrigger>
      <PopoverContent align="start" className="bg-info-50 p-[14px]">
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium text-gray-900">Update tags</h3>
            <button
              onClick={handleCancelUpdateItemTags}
              className="text-gray-400 hover:text-gray-600"
              disabled={isUpdatingItemTags}
            >
              <XIcon className="h-5 w-5" />
            </button>
          </div>

          <div className="h-px bg-gray-300" />

          <div className="flex flex-col gap-0.5">
            <label className="text-xs font-semibold text-gray-500">Tags</label>
            <InputMultiSelect
              value={itemTagsIds}
              options={tags.map((i: Tag) => ({ name: i.label, value: i.id }))}
              onChange={handleChangeItemTags}
              onSelect={() => {}}
              isDisabled={isUpdatingItemTags}
              shouldHideTitle
              className="w-full min-w-0"
              {...COMPACT_MULTI_SELECT_STYLE_PROPS}
              shouldRenderInsidePortal
              dataTestId="multiselect:tags"
            />
          </div>
          <div className="h-px bg-gray-300" />
          <button
            className="w-full rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={handleUpdateItemTags}
            disabled={isUpdatingItemTags || !hasChanges}
            data-testid="confirm-tag-update"
          >
            Save
          </button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
